import { takeCustomLatest } from 'state/common/common.effects'
import {
  backupGoogleDriveNowEffect,
  fetchGoogleDriveStatusEffect,
  fetchOverallBusinessSettingsEffect,
  trackStaffLocationEffect,
  updateBusinessSettingsEffect,
  updateImageBackupDestinationEffect,
  calculateStaffsDistanceTravelledEffect
} from './settings.effects'
import { SettingsAction } from './settings.action'

function* fetchOverallBusinessSettingsSaga() {
  yield takeCustomLatest(
    SettingsAction.FETCH_OVERALL_BUSINESS_SETTINGS,
    fetchOverallBusinessSettingsEffect
  )
}

function* updateBusinessSettingsSaga() {
  yield takeCustomLatest(
    SettingsAction.UPDATE_BUSINESS_SETTINGS_ACTION,
    updateBusinessSettingsEffect
  )
}

function* trackStaffLocationSaga() {
  yield takeCustomLatest(SettingsAction.TRACK_STAFF_LOCATION, trackStaffLocationEffect)
}

function* calculateStaffsDistanceTravelledSaga() {
  yield takeCustomLatest(
    SettingsAction.TRACK_STAFF_LOCATION_TRAVELLED,
    calculateStaffsDistanceTravelledEffect
  )
}

function* fetchGoogleDriveStatusSaga() {
  yield takeCustomLatest(SettingsAction.FETCH_GDRIVE_STATUS, fetchGoogleDriveStatusEffect)
}

function* backupGoogleDriveNowSaga() {
  yield takeCustomLatest(SettingsAction.BACKUP_GDRIVE_NOW, backupGoogleDriveNowEffect)
}

function* updateImageBackupDestinationSaga() {
  yield takeCustomLatest(
    SettingsAction.UPDATE_IMAGE_BACKUP_DESTINATION,
    updateImageBackupDestinationEffect
  )
}

export const SettingsWatcher = [
  fetchOverallBusinessSettingsSaga(),
  updateBusinessSettingsSaga(),
  trackStaffLocationSaga(),
  calculateStaffsDistanceTravelledSaga(),
  fetchGoogleDriveStatusSaga(),
  backupGoogleDriveNowSaga(),
  updateImageBackupDestinationSaga()
]
